module.exports = __webpack_public_path__ + "d6c4d9f02746e3628fa763c963e3c724.MP3";